import {
  FlatList,
  Image,
  Text,
  TouchableOpacity,
  View,
  ImageBackground,
} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import React, {useCallback, useState} from 'react';
import {
  downloadXkwUserGenerateRecordFileUrl,
  getXkwUserGenerateRecordPageGenerateDay,
  PageGenerateDayRes,
  PageGenerateRecordParams,
} from '../../API/mylearn';

import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';
import QRCodeModal from '../../components/Url2QRCode';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {useAppDispatch} from '../../store/hooks';
import {
  fetchPaperRecordDetails,
  fetchQuestionsByRecordId,
} from '../../store/xueke';

interface TopTabProps {
  list: Array<{name: string; id: number}>;
  tabIndex: number;
  setTabIndex: (index: number) => void;
}

const TopTab: React.FC<TopTabProps> = ({list, tabIndex, setTabIndex}) => {
  const renderItem = ({item}: {item: {name: string; id: number}}) => (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() => {
        setTabIndex(item.id);
      }}
      style={styles.TopTabBoxItem}>
      <Text
        style={[
          styles.TopTabBoxItemText,
          item.id === tabIndex && styles.TopTabBoxItemTextActive,
        ]}>
        {item.name}
      </Text>
      {item.id === tabIndex && (
        <Image
          style={styles.TopTabBoxItemLine}
          source={{
            uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/swk_line.png',
          }}
        />
      )}
    </TouchableOpacity>
  );
  const imageSeparator = () => (
    <View style={styles.imageSeparator}>
      <Text>|</Text>
    </View>
  );
  return (
    <>
      <View style={styles.Top}>
        <FlatList
          data={list}
          renderItem={renderItem}
          ItemSeparatorComponent={imageSeparator}
          horizontal={true} // 设置为横向展示
        />
      </View>
    </>
  );
};

interface ConProps {
  data: Array<PageGenerateDayRes>;
  handle2Status: (item: PageGenerateRecordParams) => void;
  handle2Details: (item: PageGenerateRecordParams) => void;
}

// 待下载-generated，待提交-downloaded，已完成-completed
const status: {[key: string]: {value: string; text: string}} = {
  generated: {value: '待下载', text: '下载'},
  downloaded: {value: '待完成', text: '提交作答'},
  needlessDownload: {value: '待完成', text: '提交作答'},
  completed: {value: '已完成', text: '查看解析'},
};
const tab = [
  {
    name: 'AI同步测',
    id: 1,
    value: 'studySkills',
    bg: '#FFF4D5',
    color: '#A2832B',
  },
  {
    name: '阶段测评',
    id: 2,
    value: 'phaseTesting',
    bg: '#ECFFDB',
    color: '#77A84A',
  },
  {
    name: '名校真题',
    id: 3,
    value: 'classicPapers',
    bg: '#EAEFFF',
    color: '#6377B5',
  },
  {
    name: '专题训练',
    id: 4,
    value: 'enrolmentPapers',
    bg: '#FFE9E8',
    color: '#EB716B',
  },
  {
    name: '错题巩固',
    id: 5,
    value: 'correctionTraining',
    bg: '#EDE7FF',
    color: '#8371BC',
  },
  {
    name: '诊断测评',
    id: 6,
    value: 'diagnoseTest',
    bg: '#EDE7FF',
    color: '#8371BC',
  },
];
// 科目简称
// 语文-语 数学-数 英语-英 物理-物 化学-化 生物-生 历史-史 地理-地 政治-政
const subjectName: {[key: string]: string} = {
  1: '语',
  2: '数',
  3: '英',
  4: '物',
  5: '化',
  6: '生',
  7: '政',
  8: '史',
  9: '地',
};
const Con: React.FC<ConProps> = ({data, handle2Status, handle2Details}) => {
  const formatDate = (date: string): string => {
    return date.slice(0, 4) + '-' + date.slice(4, 6) + '-' + date.slice(6);
  };
  const formatDate_title = (date: string): string => {
    return date.slice(0, 4) + '.' + date.slice(4, 6) + '.' + date.slice(6);
  };

  const renderItem = ({item}: {item: PageGenerateDayRes}) => (
    <View style={styles.ConBoxItem}>
      <View style={styles.ConBoxItemTitle}>
        <Image
          resizeMode={'contain'}
          style={styles.ConBoxItemTitleImg}
          source={{
            uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_time.png',
          }}
        />
        <Text style={styles.ConBoxItemTitleText}>
          {formatDate(item.generateDay + '')}
        </Text>
      </View>
      <View style={[styles.ConBoxItemCon, styles.flex1]}>
        <FlatList
          numColumns={2}
          data={item.generateRecords}
          renderItem={({item}: {item: PageGenerateRecordParams}) => (
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => handle2Details(item)}
              key={item.id}
              style={styles.ConBoxItemConBlock}>
              <ImageBackground
                style={styles.ConBoxItemConBlockLeftImg}
                source={{
                  uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_clogo.png?t=1',
                }}>
                <Text
                  style={[
                    styles.ConBoxItemConBlockLeftImgText,
                    {
                      color: '#fff',
                    },
                  ]}>
                  {subjectName[item.subjectId]}
                </Text>
              </ImageBackground>
              <View style={[styles.ConBoxItemConBlockRight]}>
                <View style={styles.ConBoxItemConBlockRightTop}>
                  <View
                    style={[
                      styles.ConBoxItemConBlockRightTopBG,
                      {
                        backgroundColor: tab.find(
                          i => i.value === item.moduleType,
                        )?.bg,
                      },
                    ]}>
                    <Text
                      style={[
                        styles.ConBoxItemConBlockRightTopBGText,
                        {
                          color: tab.find(i => i.value === item.moduleType)
                            ?.color,
                        },
                      ]}>
                      {tab.find(i => i.value === item.moduleType)?.name}
                    </Text>
                  </View>
                </View>
                <View style={styles.ConBoxItemConBlockRightTitle}>
                  <Text
                    style={styles.ConBoxItemConBlockRightTitleText}
                    numberOfLines={2}>
                    {item.title ||
                      tab.find(i => i.value === item.moduleType)?.name +
                        ' ' +
                        formatDate_title(item.generateDay + '')}
                  </Text>
                </View>
                <View style={styles.ConBoxItemConBlockRightBottom}>
                  <View style={styles.ConBoxItemConBlockRightBottomStatus}>
                    <Text
                      style={styles.ConBoxItemConBlockRightBottomStatusText}>
                      状态:&nbsp;&nbsp;&nbsp;
                      <Text
                        style={
                          styles.ConBoxItemConBlockRightBottomStatusTextBlod
                        }>
                        {status[item.operationStatus].value}
                      </Text>
                    </Text>
                  </View>
                  {item.operationStatus === 'needlessDownload' ? null : (
                    <TouchableOpacity
                      onPress={() => handle2Status(item)}
                      style={styles.ConBoxItemConBlockRightBottomBtn}>
                      {item.operationStatus === 'generated' && (
                        <Image
                          style={styles.ConBoxItemConBlockRightBottomBtnIcon}
                          source={{
                            uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/mylearn_cdownload.png',
                          }}
                        />
                      )}

                      <Text style={styles.ConBoxItemConBlockRightBottomBtnText}>
                        {status[item.operationStatus].text}
                      </Text>
                    </TouchableOpacity>
                  )}
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      </View>
    </View>
  );
  return (
    <>
      <View style={[styles.flex1, styles.Con]}>
        <View style={styles.ConBox}>
          <FlatList
            data={data}
            renderItem={renderItem}
            ListEmptyComponent={() => {
              return (
                <View style={[styles.TestListItemEmpty]}>
                  <Image
                    style={styles.TestListItemEmptyImage}
                    source={{
                      uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/empty.png',
                    }}
                  />
                  <Text style={styles.TestListItemEmptyText}>暂无</Text>
                </View>
              );
            }}
          />
        </View>
      </View>
    </>
  );
};
const MyLearnCenter = () => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const tabList = [
    {name: '全部', id: 0, value: ''},
    ...tab,
    // {name: '阶段测评', id: 2, value: 'phaseTesting'},
    // {name: '名校真题', id: 3, value: 'classicPapers'},
    // {name: '专题训练', id: 4, value: 'enrolmentPapers'},
  ];
  const [recordList, setRecordList] = useState<PageGenerateDayRes[]>([]);
  const getRecordList = async () => {
    showGlobalLoading({text: '加载中'});
    try {
      const type = tabList.find(i => i.id === currentTopTabIndex)?.value;
      const p = {
        page: 0,
        size: 300,
        moduleType: type ? type : '',
      };
      const res = await getXkwUserGenerateRecordPageGenerateDay(p);
      console.log(res);
      if (res.status === 200) {
        setRecordList(res.data.content);
      } else {
        Toast.show({
          type: 'error',
          text1: '获取数据失败',
        });
        setRecordList([]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  // useMount(() => {
  //   getRecordList();
  // });

  const [currentTopTabIndex, setCurrentTopTabIndex] = useState(0);
  const focusEffect = useCallback(() => {
    console.log('返回能触发');
    getRecordList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTopTabIndex]);

  useFocusEffect(focusEffect);
  // useEffect(() => {
  //   getRecordList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentTopTabIndex]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrcodeValue, setQrcodeValue] = useState('');
  const handle2Status = async (item: PageGenerateRecordParams) => {
    console.log(item);
    switch (item.operationStatus) {
      case 'generated': {
        showGlobalLoading({text: '下载中'});
        // 最长 60s 倒计时，超时则取消 每 1 秒请求一次 返回值之后停止倒计时
        let count = 0;
        const timer = setInterval(async () => {
          try {
            const p = {
              generateRecordId: item.id,
            };
            const resaa = await downloadXkwUserGenerateRecordFileUrl(p);
            count++;
            if (count > 60) {
              clearInterval(timer);
            }
            if (resaa.data.status === 2) {
              clearInterval(timer);
              hideGlobalLoading();
              // @ts-ignore
              setQrcodeValue(resaa.data.url);
              setIsModalVisible(true);
            }
            if (resaa.data.status === 3) {
              Toast.show({
                type: 'error',
                text1: '文件下载失败，请稍后重试',
              } as any);
              clearInterval(timer);
              hideGlobalLoading();
            }
            console.log('res', resaa);
          } catch (e) {
            hideGlobalLoading();
            clearInterval(timer);
            console.log(e);
          }
        }, 5000);

        break;
      }
      case 'completed': {
        showGlobalLoading({text: '加载中'});
        // @ts-ignore
        dispatch(fetchQuestionsByRecordId({generateRecordId: item.id}))
          .unwrap()
          .then(res => {
            if (res) {
              // @ts-ignore
              navigation.navigate('WorkBookParse', {
                id: item.id,
              });
            }
          })
          .finally(() => {
            hideGlobalLoading();
          });
        break;
      }
      case 'needlessDownload': {
        showGlobalLoading({text: '加载中'});
        // @ts-ignore
        dispatch(fetchQuestionsByRecordId({generateRecordId: item.id}))
          .unwrap()
          .then(res => {
            if (res) {
              // @ts-ignore
              navigation.navigate('TestDetails', {
                recordId: item.id,
              });
            }
          })
          .finally(() => {
            hideGlobalLoading();
          });
        break;
      }
      case 'downloaded': {
        showGlobalLoading({text: '加载中'});
        // @ts-ignore
        dispatch(fetchQuestionsByRecordId({generateRecordId: item.id}))
          .unwrap()
          .then(res => {
            if (res) {
              // @ts-ignore
              navigation.navigate('SubmitAnswer', {
                id: item.id,
              });
            }
          })
          .finally(() => {
            hideGlobalLoading();
          });
        break;
      }
    }
  };
  const handle2Details = (item: PageGenerateRecordParams) => {
    if (['diagnoseTest'].includes(item.moduleType)) {
      return;
    }
    showGlobalLoading({text: '加载中'});
    console.log('ccc', item);
    let api, routeName: string, p;
    if (['studySkills', 'correctionTraining'].includes(item.moduleType)) {
      api = fetchQuestionsByRecordId;
      routeName = 'WorkbookDetails';
      p = {
        generateRecordId: item.id,
      };
    } else {
      api = fetchPaperRecordDetails;
      routeName = 'PaperDetails';
      p = {
        generateRecordId: item.id,
      };
    }
    dispatch(api(p))
      .unwrap()
      .then(res => {
        if (res) {
          // @ts-ignore
          navigation.navigate(routeName, {
            title: item.title,
            id: item.id,
          });
        }
      })
      .finally(() => {
        hideGlobalLoading();
      });
  };
  return (
    // <>
    <View style={styles.flex1}>
      <TopTab
        list={tabList}
        tabIndex={currentTopTabIndex}
        setTabIndex={setCurrentTopTabIndex}
      />
      <Con
        data={recordList}
        handle2Status={item => handle2Status(item)}
        handle2Details={item => handle2Details(item)}
      />
      <QRCodeModal
        visible={isModalVisible}
        logoImg={
          'https://media.oss.leziedu.com/webapp/classroom/mylearn/logoC.png'
        }
        value={qrcodeValue}
        onClose={() => {
          setIsModalVisible(false);
          getRecordList();
        }}
      />
    </View>
    // </>
  );
};
const styles = createStyles({
  flex1: {
    flex: 1,
  },
  Top: {
    paddingHorizontal: '1rem',
  },
  TopTabBoxTop: {
    flexDirection: 'row',
  },
  TopTabBoxItem: {
    minWidth: '13.1rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '1.2rem',
    paddingHorizontal: '1.5rem',
  },
  TopTabBoxItemText: {
    fontSize: '1.6rem',
    color: '#7D7A95',
  },
  TopTabBoxItemTextActive: {
    zIndex: 2,
    color: '#6658FF',
    fontSize: '1.9rem',
    fontWeight: 'bold',
  },
  TopTabBoxItemLine: {
    zIndex: 1,
    marginTop: '-1.2rem',
    width: '5.7rem',
    height: '1.25rem',
  },
  imageSeparator: {
    // width: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  Con: {
    // flex: 1,
    height: '100%',
    flexShrink: 0,
    paddingLeft: '1.65rem', // '1.65rem
    // paddingHorizontal: '1.65rem',
    paddingBottom: '1.65rem',
  },
  ConBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    borderRadius: '1rem',
    paddingLeft: '1.45rem',
    paddingTop: '1.55rem',
  },
  ConBoxItem: {
    flexDirection: 'column',
  },
  ConBoxItemTitle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  ConBoxItemTitleText: {
    fontSize: '1.4rem',
    color: '#3d3d3d',
  },
  ConBoxItemTitleImg: {
    marginVertical: '0.2rem',
    width: '1.3rem',
    height: '1.3rem',
    marginRight: '0.75rem',
  },
  ConBoxItemCon: {
    marginVertical: '0.2rem',
    marginLeft: '0.65rem',
    paddingLeft: '1.225rem',
    paddingVertical: '0.7rem',
    borderLeftWidth: 1.3,
    borderStyle: 'dashed',
    borderColor: '#6884F9',
  },
  ConBoxItemConBlock: {
    width: '40rem',
    height: '9.9rem',
    backgroundColor: '#fff',
    marginRight: '1.5rem',
    marginBottom: '1.5rem',
    borderRadius: '1rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ConBoxItemConBlockLeftImg: {
    width: '5.45rem',
    height: '6.9rem',
    marginLeft: '1.25rem',
    flexShrink: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '0.9rem',
    paddingLeft: '0.2rem',
  },
  ConBoxItemConBlockLeftImgText: {
    fontSize: '1.45rem',
  },
  ConBoxItemConBlockRight: {
    marginLeft: '1.1rem',
    flex: 1,
    height: '100%',
  },
  ConBoxItemConBlockRightTop: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  ConBoxItemConBlockRightTopBG: {
    height: '1.75rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.875rem',
    backgroundColor: '#FFF4D5',
    paddingHorizontal: '0.65rem',
    borderTopLeftRadius: 0,
    marginTop: 1,
    marginRight: 1,
  },
  ConBoxItemConBlockRightTopBGText: {
    fontSize: '1rem',
  },
  ConBoxItemConBlockRightTitle: {
    height: '3.4rem',
    width: '26rem',
    // marginBottom: '1rem',
  },
  ConBoxItemConBlockRightTitleText: {
    color: '#3D3D3D',
    fontSize: '1.3rem',
  },
  ConBoxItemConBlockRightBottom: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '1.35rem',
  },
  ConBoxItemConBlockRightBottomStatus: {},
  ConBoxItemConBlockRightBottomStatusText: {
    color: '#999999',
    fontSize: '1.1rem',
  },
  ConBoxItemConBlockRightBottomStatusTextBlod: {
    fontWeight: 'bold',
    color: '#3D3D3D',
  },
  ConBoxItemConBlockRightBottomBtn: {
    minWidth: '6.8rem',
    height: '2.4rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: '1.55rem',
    backgroundColor: '#EAF1FF',
    borderRadius: '1.2rem',
  },
  ConBoxItemConBlockRightBottomBtnIcon: {
    marginTop: '0.3rem',
    width: '1.3rem',
    height: '1.3rem',
    marginRight: '0.4rem',
  },
  ConBoxItemConBlockRightBottomBtnText: {
    color: '#3D3D3D',
    fontSize: '1.05rem',
  },
  myLearnBoxRight: {
    marginLeft: '2.5rem',
    marginRight: '2.2rem',
    width: '7.25rem',
    height: '23rem',
    backgroundColor: '#6F63FF',
    borderRadius: '1.75rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItem: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  workBookDetailsBoxBtnItemImg: {
    width: '3.25rem',
    height: '3.25rem',
    marginBottom: '0.75rem',
  },
  workBookDetailsBoxBtnItemText: {
    color: '#fff',
    fontSize: '1.125rem',
  },
  TestListItemEmpty: {
    // flex: 1,
    marginTop: 100,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  TestListItemEmptyImage: {
    width: '19.05rem',
    height: '15rem',
  },
  TestListItemEmptyText: {
    fontSize: '1.4rem',
    color: '#666666',
    marginLeft: '2.85rem',
  },
});
export default MyLearnCenter;
